"use strict";

const FollowUpInformal = function () {
  var loadListeners = function ($modal) {
    $modal.on("2N:FormInput", "[name='inspection-type']", handleFollowUpInformal);
    handleFollowUpInformal();
  };

  var unloadListeners = function ($modal) {
    $modal.off("2N:FormInput", "[name='inspection-type']", handleFollowUpInformal);
  };

  var handleFollowUpInformal = function () {
    const isFollowUpInformal = $("[name='inspection-type']").val() === "follow-up-informal";
    $(".inspector-or-reviewer").text(isFollowUpInformal ? "Reviewer" : "Inspector");
    $(".hide-follow-up-informal").toggleClass("hidden", isFollowUpInformal);
  };

  return {
    loadListeners,
    unloadListeners,
  };
};

module.exports = FollowUpInformal();
